import { render } from "./AddStaff.vue?vue&type=template&id=d7dd17f8&ts=true"
import script from "./AddStaff.vue?vue&type=script&lang=tsx"
export * from "./AddStaff.vue?vue&type=script&lang=tsx"

import "./AddStaff.vue?vue&type=style&index=0&id=d7dd17f8&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__